module.exports = __webpack_public_path__ + "img/cost-free.e659af08.svg";